import { render } from "./VisitManagement.vue?vue&type=template&id=fb389d24&scoped=true"
import script from "./VisitManagement.js?vue&type=script&lang=js"
export * from "./VisitManagement.js?vue&type=script&lang=js"

import "./VisitManagement.vue?vue&type=style&index=0&id=fb389d24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb389d24"]])

export default __exports__